import React from 'react';
import { Row, Col, Card } from 'react-bootstrap';

const CommercialStatus = ({ stats }) => {
    return (
        <Row >
            <Col lg={6} md={6} className="mb-4">
                <Card className="stats-card text-white" style={{ background: 'linear-gradient(135deg, var(--brand-burgundy) 0%, var(--brand-red-medium) 100%)' }}>
                    <Card.Body className="text-center">
                        <div className="display-4 fw-bold">{stats.total_organizations || '-'}</div>
                        <div className="fs-6">Total Organizations</div>
                    </Card.Body>
                </Card>
            </Col>
            <Col lg={6} md={6} className="mb-4">
                <Card className="stats-card text-white" style={{ background: 'linear-gradient(135deg, var(--brand-red-medium), var(--brand-red-bright))' }}>
                    <Card.Body className="text-center">
                        <div className="display-4 fw-bold">{stats.active_subscriptions || '-'}</div>
                        <div className="fs-6">Active Subscriptions</div>
                    </Card.Body>
                </Card>
            </Col>
        </Row >
    );
};

export default CommercialStatus;
